import {
  APPLY_FILTERS,
  SET_ACTIVE_CONTRACTS,
  SET_CLOSE_CONTRACTS,
  SET_CLIENT_DETAIL,
  SET_CLIENT_NOTES,
  SET_CLIENT_DOCS,
  SET_CLIENT_DOC_TYPES,
  SET_CLIENT_BANK_ACCOUNTS,
  SET_CHECK_CONTRACT_COMPONENT,
  SET_CONTRACTS
} from './types';

export const INIT_STATE = {
  filters: {
    page: 1,
    pageSize: 10,
  },
  totalActiveContracts: 0,
  totalCloseContracts: 0,
  contracts: [],
  activeContracts: [],
  closedContracts: [],
  targetingClient: {},
  notes: [],
  docs: [],
  clientDocTypes: [],
  clientBankAccounts: [],
  checkContract: false,
};

const mutations = {
  [APPLY_FILTERS](state, filters) {
    state.filters = {
      ...state.filters,
      ...filters
    };
  },

  [SET_CONTRACTS](state, { items }) {
    state.contracts = [...items];
  },

  [SET_ACTIVE_CONTRACTS](state, { items, total }) {
    state.activeContracts = [...items];
    state.totalActiveContracts = total;
  },

  [SET_CLOSE_CONTRACTS](state, { items, total }) {
    state.closedContracts = [...items];
    state.totalCloseContracts = total;
  },

  [SET_CLIENT_DETAIL](state, result) {
    state.targetingClient = { ...result };
  },

  [SET_CLIENT_NOTES](state, result) {
    state.notes = result;
  },

  [SET_CLIENT_DOC_TYPES](state, result) {
    state.clientDocTypes = result;
  },

  [SET_CLIENT_DOCS](state, result) {
    state.docs = result;
  },

  [SET_CLIENT_BANK_ACCOUNTS](state, result) {
    state.clientBankAccounts = result;
  },

  [SET_CHECK_CONTRACT_COMPONENT](state, check) {
    state.checkContract = check;
  }
};

export default mutations;
